import React, { Component } from 'react';

import './MediaStatus.css';

import { background_10, services4 } from '../../theme/images';
import Page from '@acri-tools/react-tools/components/Page/Page';
import Documents from '../../components/Documents/Documents';
import { DOCUMENT_CATEGORIES } from '../../utils/documents';
import { get_page_title } from '../../utils/config';
import { Helmet } from 'react-helmet';

interface Props{
}
interface State{
}

class MediaStatus extends Component<Props,State>{
    render(){
        return (
        <Page 
            id="media-status"
            banner={{
                title: "media status",
                bannerImage: background_10,
                topBar: true
            }}
            footer
        >
            <Helmet>
                <title>{ get_page_title('DAMPS - Media Status') }</title>
                <meta 
                    name="description" 
                    content="The DAMPS media status"
                />
            </Helmet>
            <div className="page-content">
                <div className="centered-content padding">
                    {
                        DOCUMENT_CATEGORIES["MediaStatus"]?.map((category:string, index:number)=>(
                            <Documents
                                default_toggled={index === 0}
                                category={category}
                            />
                        ))
                    }
                </div>
            </div>
        </Page>
        );
    }

};


export default MediaStatus;
